import AnalyticsIcon from '@mui/icons-material/Analytics';

const icons = {
  AnalyticsIcon
};

const networkMIS = {
  id: 'netwrokmis',
  type: 'group',
  children: [
    {
      id: 'mis',
      title: 'Master MIS',
      type: 'item',
      url: '/MIS-REPORT',
      icon: icons.AnalyticsIcon,
    }
  ]
};

export default networkMIS;
